



















import Vue, { PropOptions } from 'vue';
import {ISelectOption as iso} from '@/class/models/typed/wild';
import {strFuzzyMatch} from '@/class/common/util';
import SearchResult from '@/components/util/SearchResult.vue';
export type IOption = iso;

export default Vue.extend({
  name: 'MultiSelectSearchBox',
  components: { SearchResult },
  props: {
    initialValue: {
      type: String,
      default: '',
    },
    options: Array as PropOptions<iso[]>,
    excludeOptions: Array as PropOptions<any[]>,
    noneOptionsText: {
      type: String,
      default: '選択できる項目がありません',
    },
  },
  data() {
    return {
      searchText: '',
      selectList: [] as number[],
      editSelectList: [] as number[],
    };
  },
  watch: {
    initialValue: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectList = this.importSetData(val);
          this.editSelectList = [ ...this.selectList ];
        } else {
          this.editSelectList = [];
        }
      },
    },
  },
  computed: {
    OPTIONS(): IOption[] {
      let result = [ ...this.options ];
      if (this.excludeOptions && this.excludeOptions.length) {
        result = result.filter((v) => !this.excludeOptions.some((v2) => v.value === v2.value));
      }
      if (this.searchText) {
        result = result.filter((v) => this.matchOptionText(v.text));
      }
      return result;
    },
  },
  mounted() {
    if (this.initialValue) {
      this.selectList = this.importSetData(this.initialValue);
      this.editSelectList = [ ...this.selectList ];
    } else {
      this.editSelectList = [];
    }
  },
  methods: {
    onClickItem(value: number) {
      const clickedIndex = this.editSelectList.findIndex((v) => v === value);
      if (clickedIndex > -1) { // 削除
        this.editSelectList.splice(clickedIndex, 1);
      } else { // 追加
        this.editSelectList.push(value);
      }
      const selectStr = this.exportSetData(this.editSelectList);
      this.$emit('change', selectStr || '');
    },
    importSetData(initialValue: string): number[] {
      const initialList = initialValue.split(',');
      const editSelectList: number[] = [];
      for (const value of initialList) {
        editSelectList.push(Number(value));
      }
      return editSelectList;
    },
    exportSetData(selectList: number[]): string {
      let textArray = selectList.map((v) => String(v));
      // 空白と重複を排除して連結
      textArray = Array.from(new Set(textArray.filter((v) => v !== '')));
      return textArray.join(',');
    },
    matchOptionText(text: string): string | null {
      return strFuzzyMatch(this.searchText, text);
    },
  },
});
